import React from 'react'

class InputHint extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="guide-tips">
          <span
            className="guide-tips-label"
            dangerouslySetInnerHTML={{
              __html: this.props.content,
            }}
          ></span>
        </div>
      </React.Fragment>
    )
  }
}

export default InputHint
